export type PostalInfo = {
  city: string;
  state: string;
  stateDesc: string;
  zip: string;
  country: string;
  countryName: string;
  stateName: string;
};

export type CountryInfo = {
  countryCode: string;
  countryName: string;
  presentationOrder: number;
  countryCallingCode: string;
  postalCode: null;
  stateCode: null;
  postal: null;
};

export type State = {
  stateCode: string; // 'AL'
  stateDesc: string; // 'ALABAMA'
};

export type City = {
  cityName: string;
  postalCode: string;
  postalKey: number;
  state: State;
  country: CountryInfo;
  countryCode: null;
};

export type Company = {
  companyId: number;
  companyName: string;
  customerStatus: string | null;
  ownerID: 2 | 0; // 2 - for customer, 0 - for vendor or carrier
  customerAddr1: string | null;
  customerAddr2: string | null;
  customerCity: string | null;
  customerState: string | null;
  customerZip: string | null;
};

export const WEIGHT_UOMS = {
  KG: { label: 'Kilogram', value: 'KG' },
  LB: { label: 'Pound', value: 'LB' },
  OZ: { label: 'OUNCE', value: 'OZ' },
} as const;

export type WeightUOM = keyof typeof WEIGHT_UOMS;
export type WeightUOMDescription = (typeof WEIGHT_UOMS)[keyof typeof WEIGHT_UOMS]['label'];

export type LengthUOM = 'INCH' | 'CM';
export type LengthUOMDescription = 'Inches' | 'Centimeter';
export type LengthUOMProductId = 'N' | 'C';
export type LengthUOMProductDesc = 'cms' | 'inches';

export type PortType = 'AIR' | 'SEA' | 'RAIL';
export type PortTypeDescription = 'Air Port' | 'Ocean Port' | 'Rail Port';

export type Port = {
  portRecKey: number;
  portCode: string;
  portType: PortType;
  portName: string;
  portCity: string;
  portStateCode: string;
  stateDesc: string;
  portCountryCode: string;
  portZip: string;
  countryName: string;
  stateName: string;
};

export type AllowedExtension = {
  fileTypeID: number;
  allowExtension: string;
  moduleID: number;
  active: string;
  createdBy: number;
  createdOn: string; // '0001-01-01T00:00:00';
  modifiedBy: number | null;
  modifiedOn: string | null;
};
